const routeMain = () => "/";

export default routeMain;
